import type { SwymSessionInfoResponse } from '@ds/swymkit/tools'
import { SERVICE } from '@ds/swymkit/tools'

/**
 * Init startup info such as Swym CSRF and ID for localstorage
 */
export async function setupApplicationStartupInfo() {
  // #region Init CSRF/UserID
  const { swymFetch } = await import('~/services/fetch-swym')
  // fetch the CSRF / User ID
  const { csrfToken, user: { externalId } } = (
    await swymFetch
      .get('/api/session/info')
      .json<SwymSessionInfoResponse>()
  )

  // Set user ID for local storage manager
  const { setupUserIdForLocalStorageManager } = await import('~/features-generic/config-manager/utils/local-storage-manager')
  setupUserIdForLocalStorageManager(externalId)

  // Set CSRF for Swym
  const { initCsrfFromTokenOrSessionStorage } = await import('@ds/swymkit/tools')
  initCsrfFromTokenOrSessionStorage(SERVICE.SWYM, csrfToken)
  // #endregion
}
